import { Box, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";

export function Footer() {
  const { t } = useI18n();
  return (
    <Box asChild className="rk-footer">
      <footer>
        <Text size="1" color="gray">
          {t("footer.source")}
        </Text>
      </footer>
    </Box>
  );
}
